import React from 'react';
import Button from '../../components/buttons/Button';
import ButtonPlano from './ButtonPlano';
import STRINGS from './../../data/language/language';
import Dialog from '../../components/alert/Dialog';
import PlanosDescricao from './PlanosDescricao';
import Modal from '../../components/modal.v2/Modal';

import './styles-form-plano.css';

export default class Pagamento extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      planos: props.data.planos,
      strings: STRINGS[window.LANGUAGE]
    };

    this.changePlano = this.changePlano.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openPlanoDesc = this.openPlanoDesc.bind(this);
  }

  changePlano(event, id){
    this.setState({
      ativo: id
    });
    event.preventDefault();

  }

  openPlanoDesc(e){
    e.preventDefault();

    Modal.create({
      content: <PlanosDescricao planos={this.state.planos} />
    });
  }

  getPlano(id) {
    let plano;
    let lista = this.state.planos.map((value, i) =>{
      if(id === value.id){
        plano = value;
      }
    });
    return plano;
  }

  handleSubmit() {
    const { ativo } = this.state;
    const {
      atencao,
      escolhaPlano
    }
    = this.state.strings;

    if( ativo ){
      const plano = this.getPlano(this.state.ativo);
      this.props.changeBox(plano);
      //
    }else{
      const msg = {
        title: atencao,
        text: escolhaPlano
      };
      Dialog.create(msg);
    }
  }

  renderPlanos() {
    const ativo = this.state.ativo;

    let lista = this.state.planos.map((value, i) =>{
      const ativoCheck = ativo ? value.id === ativo : false;
      return(
        <ButtonPlano
          key={i}
          title={value.nome}
          subtitle={value.descricao}
          valor={value.valor}
          periodo={value.periodicidadeDesc}
          ativo={ativoCheck}
          onClick={(event)=>this.changePlano(event, value.id)}
        />
      );
    });
    return lista;
  }

  render(){
    const planos = this.renderPlanos();
    return(
      <div>
        <strong className='title-pagamento'>Escolha o plano</strong>
        <div>
          <ul className='list-planos'>
          {planos}
          </ul>
          <div className="box-center-button">
            <div className='box-saiba-mais-planos'><a href='#' onClick={this.openPlanoDesc}>Clique aqui e saiba mais sobre os planos</a></div>
            <Button
              text="Continuar"
              type='button'
              classes="button-login simple-button"
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/Planos.js